<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-sm-4 col-md-3">
            <bita-bootbutton
              type="primary"
              title="افزودن دسته بندی"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="createCategory"
            />
          </div>
          <hr />
          <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="editForm"
      modal-id="edit-modal"
      title="ویرایش دسته بندی"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :props-data="editForm"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="افزودن دسته بندی"
      @on-submit="handleCreate"
    />
  </div>
</template>
<script>
import Form from "./Form";
export default {
  components: { "form-modal": Form },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت دسته بندی",
          link: "/articles/categories",
          active: true,
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      category: {
        name: "",
      },
      editForm: { asfas: "asfasf" },
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام دسته بندی" },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
        {
          title: "عملیات",
          command: [],
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
  },
  methods: {
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$resetGrid();
      this.$persistClient("get", "categories")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    save() {
      this.$refs.test.validate().then((result) => {
        if (result) {
          this.isLoadingForm = true;
          this.$persistClient("post", "categories", this.category)
            .then((res) => {
              this.$izitoast(
                "success",
                "عملیات موفق",
                "دسته بندی مورد نظر ایجاد شد"
              );
              this.category = {
                name: "",
              };
              this.$refs.test.reset();
            })
            .finally(() => {
              this.isLoadingForm = false;
            });
        }
      });
    },
    edit(e) {
      this.editForm = this.$refs.grid.getSelectedGridRow(e);
      this.statusChangeModalEdit();
    },
    delete(e) {
      let category = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف ${category.name} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `categories/${category.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    createCategory() {
      this.editForm = {};
      this.statusChangeModalCreate();
    },
    handleEdit(e) {
      this.isLoadingModal = true;
      let data = {
        id: e.id,
        name: e.name,
      };
      this.$persistClient("patch", `categories/${e.id}`, data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalEdit();
        });
    },
    handleCreate(e) {
      this.isLoadingModal = true;
      let data = {
        id: e.id,
        name: e.name,
      };
      this.$persistClient("post", "categories", data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalCreate();
        });
    },
  },
};
</script>
